import { render, staticRenderFns } from "./vipLevel.vue?vue&type=template&id=21a8a5c3&scoped=true"
import script from "./vipLevel.vue?vue&type=script&lang=js"
export * from "./vipLevel.vue?vue&type=script&lang=js"
import style0 from "./vipLevel.vue?vue&type=style&index=0&id=21a8a5c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8a5c3",
  null
  
)

export default component.exports